const testInternetExplorer = false;

global.isInternetExplorer = testInternetExplorer || require('isInternetExplorer');

var localJQueryExists = typeof jQuery !== "undefined";

if(!localJQueryExists){ global.jQuery = require('jquery') } 

if(!localJQueryExists){ require('transition') } 
if(!localJQueryExists){ require('dropdown') } 
if(!localJQueryExists){ require('collapse') } 
if(!localJQueryExists){ require('modal') } 


require('clockpicker');                  // 
require('bootstrap-datepicker-webpack'); //
require('jquery-file-download');         //
require('bootstrap-select');              //
require('knockout.typeahead'); // overwriting typeahead binding in knockout helpers - TODO separate typeahead&bloodhound
require('slick-carousel');
require('leaflet');

var $                          = global.jQuery;
var helpers                    = require('Helpers.js');
var core                       = require('./CoreModule');
    ko                         = require('knockout');
var kov                        = require('knockout.validation')
    _                          = require('lodash');
var KOHelpers                  = require('KnockoutHelpers')($,_,ko,helpers, core.Moment);
var AppController              = require('./core/controllers/AppController.js');
var ApplicationStateController = require('./core/controllers/ApplicationStateController.js');
var SearchServerController     = require('./core/controllers/SearchServerController.js');
var ViewController             = require('./client/controllers/ViewController.js');
var ModalController            = require('./client/controllers/ModalController.js');
var emitter                    = require('events');
var store                      = require('amplify-store');
var titleMap                   = {};


var Mutex = require('Mutex.js');
global.mutex = new Mutex();

require('KOSTORAGE')(ko,store);

    [{ componentName  : 'splashscreen-view'        , config: require('SplashScreenView'            )}
    , { componentName : 'login-view'               , config: require('LoginView'                   )}
    , { componentName : 'busy-view'                , config: require('BusyView'                    )}
    , { componentName : 'split-view'               , config: require('SplitView'                   )}
    , { componentName : 'picturegrid-view'         , config: require('PictureGridView_carousel'    )}
  //, { componentName : 'picturefilters-view'      , config: require('PictureFiltersView'          )}
    , { componentName : 'picturefilters-view'      , config: require('PictureFiltersCascadingView' )}
    , { componentName : 'paginationcontrol-view'   , config: require('PaginationControlView'       )}

    , { componentName : 'wavy-loader'              , config : { template: require('WavyLoader.html') }

}
  
// add view modules here as we go

    ].forEach(function (x) { ko.components.register(x.componentName, x.config); titleMap[x.componentName] = x.config.title })
  

var appContainerTemplate = _.template(require('AppContainerView.html'))
    , _modalController   = null
    , getModalController = function () { return _modalController || (_modalController = new ModalController($, ko, _, core, KOHelpers, helpers)) }

core.Repository.on('changes', function (changes) { core.Events.emitter.emit(core.Events.repository_changes, changes) });

function DataCaptureApp(params) {

    self = this;

    var interControllerEmitter = new emitter();

    self.AppController              = new AppController(_, ko, core, self.CallStateService, helpers, core.Events, interControllerEmitter, console);
                                    
    self.ViewController             = new ViewController($, ko, _, core, helpers, core.Events, interControllerEmitter, console, titleMap);
             
    self.SearchServerController     = new SearchServerController(self.AppController, _, core, helpers, interControllerEmitter, console, core.Events, $);
    
    self.ApplicationStateController = new ApplicationStateController(_, core, params, helpers, core.Events, interControllerEmitter, console, self.AppController, self.SearchServerController);
    
    return self.ApplicationStateController.bootstrap.then(function(startupState){

             return self.AppController.init(params, startupState, self.ApplicationStateController, self.SearchServerController)
             .then(function(){ return startupState })
            
        })
        .then(function(startupState){
            return self.ViewController.init(params, startupState, self.ApplicationStateController);
           
        })
        .then(function(){
                global.AppController = self.AppController;
                 KOHelpers.safeApplyBindings(self.ViewController, "DataCaptureAppView");
        });
}


var getElement = function () {
        var scriptsWithCallId = $('script[data-api-key*="903E226A-C74D-465A-A394-FF92195ED99C"]');
        return scriptsWithCallId[0];
}
    getPluginParams = function (storageProvider) {

    var element = getElement();

    return element && { element             : $(element),
                        dataApiKey          : element.getAttribute('data-api-key'),
                        apiHost             : global.testHost || element.getAttribute('data-api-host'),                       
                        apiProtocol         : element.getAttribute('data-api-protocol') || 'http', 
                        sessionToken        : global.session  || element.getAttribute('data-fusion-session-token'), 
                        deviceIdentifier    : 'PETESPC',
                        application         : 'FusionApi',
                        fullPage            : element.getAttribute('data-fullpage') && _.toLower(element.getAttribute('data-fullpage')) === 'true',
                        height              : element.getAttribute('data-height') || '600px'   ,
                        galleryKey          :(element.getAttribute('data-gallery-key') || storageProvider.store('reloadKey') || '').toUpperCase()
                        
                      };

}

, hasQueryKey = function (storageProvider) {

    var keyFromURL = helpers.getParameterByName('galleryKey');

    if(keyFromURL){ //&& !getElement().getAttribute('data-gallery-key') ){

        storageProvider.store('reloadKey', keyFromURL);
        return true;
    }
    
}

, modal = function (message) {

    console.error('showing modal', message);

    return getModalController().Header('Field Sales Solutions photo gallery').Body(message).show();    
}

, hasNewDBVersion = function (storageProvider, key, database) { return function(){
    
    var currentVersion = database.md5
      , storedVersion  = storageProvider.store(key)
      , versionsMatch  = currentVersion === storedVersion;

    console.log('checking db version', key, storedVersion, currentVersion);

    if(storedVersion && versionsMatch) return false;

    storageProvider.store(key, currentVersion);
    
    return !storedVersion || modal('The application has been upgraded to a new version and needs to restart.\n\nYou will lose any photo selection remembered from last time.\n\nSorry for any inconvenience.');

}}

, deleteDB = function(){ return core.Promise.all(_.invokeMap([core.Repository, ApplicationStateController.__applicationStateDb] , 'delete' ) ) }


, setUpApiEndpoint = function (params) {
    if (!params) return alert('Invalid plug-in configuration');
    if (!(params.apiHost && params.apiProtocol)){
        var msg = 'Invalid plugin API endpoint configuration';
        console.error(msg, params);
        throw alert(msg) || msg;    
    }

    global.apiEndpoint = params.apiProtocol + "://" + params.apiHost + "/api/";

}


$(document).ready(function () {

    var storageProvider    = ko.storage.createStorageProvider('app', 'guest', 7 * 24 * 60 * 60000)
     ,  applicationStateDB = ApplicationStateController.__applicationStateDb
     ,  redirectCheckDB1
     ,  redirectCheckDB2;
    

    core.Promise.resolve(true)    
    .then(hasNewDBVersion(storageProvider, 'dbv1', core.Repository   )).then(function (dbv1) { redirectCheckDB1 = dbv1 })
    .then(hasNewDBVersion(storageProvider, 'dbv2', applicationStateDB)).then(function (dbv2) { redirectCheckDB2 = dbv2 })
    .then(function () { 
        
        var redirectCheckKey = hasQueryKey(storageProvider);
        // must complete all checks before redirect
        if(redirectCheckKey)                     return                 helpers.redirectPageWithoutQuery();
        if(redirectCheckDB1 || redirectCheckDB2) return deleteDB().then(helpers.redirectPageWithoutQuery);

        var params = getPluginParams(storageProvider);
        
        if (!params) return modal('Invalid plug-in configuration');

        setUpApiEndpoint(params);

        params.element.replaceWith(appContainerTemplate(params)).height(150);

        var dataCaptureApp = new DataCaptureApp(_.omit(params,'element'));

    });

});
